module.exports = "https://kiosk-santa-rosa.mercywellness.com/_next/static/images/empty-placeholder-139ed2f2573b773c352dc266e3efe36a.png";